export default "__VITE_ASSET__e1acf9a1__"